import { customerApi } from "../../utils/apiConfig";

// POST
export const getKalipHizAnalizi = ({
  startDate,
  endDate,
  makinaAdi,
  urunTipi,
}) => {
  const body = {
    startDate,
    endDate,
  };

  if (
    makinaAdi !== undefined &&
    makinaAdi !== null &&
    makinaAdi !== "" &&
    makinaAdi !== "all"
  ) {
    body.makinaAdi = Number(makinaAdi);
  }

  if (
    urunTipi !== undefined &&
    urunTipi !== null &&
    urunTipi !== "" &&
    urunTipi !== "all"
  ) {
    body.urunTipi = urunTipi;
  }

  return customerApi.post("/getKalipHizAnalizi", body, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getAylikKalipKullanimAnalizi = ({
  startDate,
  endDate,
  makinaAdi,
  urunTipi,
}) => {
  const body = {
    startDate,
    endDate,
  };

  if (
    makinaAdi !== undefined &&
    makinaAdi !== null &&
    makinaAdi !== "" &&
    makinaAdi !== "all"
  ) {
    body.makinaAdi = Number(makinaAdi);
  }

  if (
    urunTipi !== undefined &&
    urunTipi !== null &&
    urunTipi !== "" &&
    urunTipi !== "all"
  ) {
    body.urunTipi = urunTipi;
  }

  return customerApi.post("/getAylikKalipKullanimAnalizi", body, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};
